/* Shop Africa USA — theme interactions */
(function () {
  'use strict';

  // Mobile menu toggle
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var open = mobileNav.hasAttribute('hidden');
      if (open) { mobileNav.removeAttribute('hidden'); } else { mobileNav.setAttribute('hidden', ''); }
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  // Ajax add-to-cart for product cards (progressive enhancement)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.pcard__form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var id = form.querySelector('input[name="id"]').value;
    if (btn) { btn.disabled = true; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) {
        var badge = document.querySelector('[data-cart-count]');
        if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }
        if (window.CartDrawer) { window.CartDrawer.render(cart); window.CartDrawer.open(); }
        if (btn) {
          btn.disabled = false;
          btn.classList.add('is-added');
          var orig = btn.innerHTML;
          btn.innerHTML = 'Added \u2713';
          setTimeout(function () { btn.innerHTML = orig; btn.classList.remove('is-added'); }, 1400);
        }
      })
      .catch(function () { if (btn) { btn.disabled = false; } form.submit(); });
  });
})();

/* ---- Mobile accordion ---- */
document.addEventListener('click', function (e) {
  var head = e.target.closest('[data-acc-toggle]');
  if (!head) return;
  var panel = head.nextElementSibling;
  var open = head.getAttribute('aria-expanded') === 'true';
  head.setAttribute('aria-expanded', String(!open));
  if (panel) { if (open) { panel.setAttribute('hidden', ''); } else { panel.removeAttribute('hidden'); } }
});

/* ---- Mega-menu keyboard a11y ---- */
(function () {
  var items = document.querySelectorAll('.nav__item');
  items.forEach(function (item) {
    var trigger = item.querySelector('a[aria-haspopup]');
    var mega = item.querySelector('.mega');
    if (!trigger || !mega) return;
    item.addEventListener('focusin', function () { trigger.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('focusout', function () {
      if (!item.contains(document.activeElement)) { trigger.setAttribute('aria-expanded', 'false'); }
    });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { trigger.setAttribute('aria-expanded', 'false'); trigger.blur(); }
    });
  });
})();

/* ---- Recently-bought social-proof toast ---- */
(function () {
  var toast = document.getElementById('rbToast');
  var data = document.getElementById('rbData');
  if (!toast || !data) return;
  var items;
  try { items = JSON.parse(data.textContent); } catch (err) { return; }
  if (!items || !items.length) return;
  var nameEl = document.getElementById('rbName');
  var metaEl = document.getElementById('rbMeta');
  var imgEl = document.getElementById('rbImg');
  var i = 0;
  var firstDelay = parseInt(data.getAttribute('data-first') || '2500', 10);
  var interval = parseInt(data.getAttribute('data-interval') || '9000', 10);
  function show() {
    var it = items[i % items.length]; i++;
    if (nameEl) nameEl.textContent = it.who;
    if (metaEl) metaEl.innerHTML = 'bought <b>' + it.prod + '</b> &middot; ' + (it.ago || 'just now');
    if (imgEl) {
      if (it.img) { imgEl.style.backgroundImage = 'url(' + it.img + ')'; imgEl.style.backgroundSize = 'cover'; }
      else { imgEl.style.background = it.dep || 'var(--palm)'; }
    }
    toast.classList.add('show');
    setTimeout(function () { toast.classList.remove('show'); }, 4500);
  }
  var closeBtn = toast.querySelector('.rb-toast__x');
  if (closeBtn) closeBtn.addEventListener('click', function () { toast.classList.remove('show'); toast.dataset.dismissed = '1'; });
  setTimeout(function () { if (!toast.dataset.dismissed) { show(); if (!window.__rbInt) window.__rbInt = setInterval(function () { if (!toast.dataset.dismissed) show(); }, interval); } }, firstDelay);
})();

/* ---- Collection sort ---- */
document.addEventListener('change', function (e) {
  var sel = e.target.closest('[data-sort]');
  if (!sel) return;
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', sel.value);
  url.searchParams.delete('page');
  window.location.href = url.toString();
});

/* ============================================================
   CART DRAWER + free-shipping progress
   ============================================================ */
(function () {
  var root = document.querySelector('[data-cart-drawer]');
  if (!root) return;
  var threshold = parseInt(root.getAttribute('data-free-threshold') || '0', 10); // cents
  var itemsEl = root.querySelector('[data-cart-items]');
  var emptyEl = root.querySelector('[data-cart-empty]');
  var footEl  = root.querySelector('[data-cart-foot]');
  var subEl   = root.querySelector('[data-cart-subtotal]');
  var countEl = root.querySelector('[data-cart-count-text]');
  var shipBar = root.querySelector('[data-ship-bar]');
  var shipMsg = root.querySelector('[data-ship-msg]');
  var shipFill= root.querySelector('[data-ship-fill]');

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }

  function render(cart) {
    if (countEl) countEl.textContent = cart.item_count;
    var badge = document.querySelector('[data-cart-count]');
    if (badge) { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; }

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (emptyEl) emptyEl.hidden = false;
      if (footEl) footEl.hidden = true;
      if (shipBar) shipBar.hidden = true;
      return;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (footEl) footEl.hidden = false;
    if (shipBar) shipBar.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (it, i) {
      var img = it.image ? '<img src="' + it.image + '" alt="">' : '<span class="cart-item__ph"></span>';
      var variant = (it.variant_title && it.variant_title !== '' && it.variant_title !== null)
        ? '<span class="cart-item__variant">' + it.variant_title + '</span>' : '';
      return '<div class="cart-item" data-line="' + (i + 1) + '">' +
        '<div class="cart-item__media">' + img + '</div>' +
        '<div class="cart-item__info">' +
          '<a href="' + it.url + '" class="cart-item__title">' + it.product_title + '</a>' + variant +
          '<div class="cart-item__price">' + money(it.final_price) + ' each</div>' +
          '<div class="cart-qty"><button data-line-minus aria-label="Decrease">&minus;</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button data-line-plus aria-label="Increase">+</button></div>' +
          '<button class="cart-item__remove" data-line-remove>Remove</button>' +
        '</div>' +
        '<div class="cart-item__line">' + money(it.final_line_price) + '</div>' +
      '</div>';
    }).join('');

    if (subEl) subEl.textContent = money(cart.total_price);

    if (threshold > 0 && shipBar) {
      var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
      if (shipFill) shipFill.style.width = pct + '%';
      if (cart.total_price >= threshold) {
        shipMsg.innerHTML = "&#127881; You've unlocked <b>free shipping!</b>";
        shipBar.classList.add('is-unlocked');
      } else {
        shipMsg.innerHTML = "You're <b>" + money(threshold - cart.total_price) + "</b> away from free shipping";
        shipBar.classList.remove('is-unlocked');
      }
    } else if (shipBar) { shipBar.hidden = true; }
  }

  function refresh() { return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { render(c); return c; }); }
  function open() { root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function close() { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  function change(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); open(); refresh(); return; }
    if (e.target.closest('[data-cart-close]')) { close(); return; }
    var line = e.target.closest('[data-line]');
    if (!line) return;
    var qtyEl = line.querySelector('.cart-qty span');
    var cur = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-line-plus]')) { change(parseInt(line.dataset.line, 10), cur + 1); }
    else if (e.target.closest('[data-line-minus]')) { change(parseInt(line.dataset.line, 10), Math.max(0, cur - 1)); }
    else if (e.target.closest('[data-line-remove]')) { change(parseInt(line.dataset.line, 10), 0); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  window.CartDrawer = { open: open, close: close, render: render, refresh: refresh };
})();

/* ============================================================
   PREDICTIVE SEARCH
   ============================================================ */
(function () {
  var root = document.querySelector('[data-search-drawer]');
  if (!root) return;
  var input = root.querySelector('[data-search-input]');
  var results = root.querySelector('[data-search-results]');
  var form = root.querySelector('form');
  var hint = '<p class="search-hint">Popular: Suya pepper &middot; Ankara &middot; Agbada &middot; Shea butter &middot; Egusi</p>';

  function open() { root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; setTimeout(function () { if (input) input.focus(); }, 90); }
  function close() { root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function priceStr(p) {
    if (p == null) return '';
    if (typeof p === 'number') return '$' + (p / 100).toFixed(2);
    if (/^\d+$/.test(p)) return '$' + (parseInt(p, 10) / 100).toFixed(2);
    return p;
  }

  var timer;
  function run(q) {
    if (!q || q.length < 2) { results.innerHTML = hint; return; }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=7&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data.resources && data.resources.results) || {};
        var products = res.products || [];
        var collections = res.collections || [];
        if (!products.length && !collections.length) {
          results.innerHTML = '<p class="search-hint">No matches for &ldquo;' + q + '&rdquo;. Try another term.</p>';
          return;
        }
        var html = '';
        if (collections.length) {
          html += '<div class="search-cols">' + collections.slice(0, 5).map(function (c) {
            return '<a class="search-col" href="' + c.url + '">' + c.title + '</a>';
          }).join('') + '</div>';
        }
        if (products.length) {
          html += '<div class="search-sectitle">Products</div><div class="search-list">' + products.map(function (p) {
            var imgurl = (p.featured_image && p.featured_image.url) || p.image || '';
            var img = imgurl ? '<img src="' + imgurl + '" alt="">' : '<span class="search-item__ph"></span>';
            var price = priceStr(p.price);
            return '<a class="search-item" href="' + p.url + '">' +
              '<span class="search-item__media">' + img + '</span>' +
              '<span class="search-item__info"><span class="search-item__title">' + p.title + '</span>' +
              (p.vendor ? '<span class="search-item__vendor">by ' + p.vendor + '</span>' : '') + '</span>' +
              (price ? '<span class="search-item__price">' + price + '</span>' : '') + '</a>';
          }).join('') + '</div>';
        }
        html += '<a class="search-all" href="' + form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&type=product">See all results for &ldquo;' + q + '&rdquo; &rarr;</a>';
        results.innerHTML = html;
      })
      .catch(function () {});
  }

  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { run(q); }, 220);
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]')) { close(); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  window.SearchDrawer = { open: open, close: close };
})();

/* ============================================================
   PRODUCT PAGE — gallery, variants, sticky add-to-cart
   ============================================================ */
(function () {
  // gallery thumbnail swap
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    gallery.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gthumb]');
      if (!t) return;
      var i = t.getAttribute('data-gthumb');
      gallery.querySelectorAll('[data-gimg]').forEach(function (img) { img.classList.toggle('is-active', img.getAttribute('data-gimg') === i); });
      gallery.querySelectorAll('[data-gthumb]').forEach(function (b) { b.classList.toggle('is-active', b === t); });
    });
  }

  var form = document.querySelector('.product-form');
  if (!form) return;
  var variants = [];
  var vt = form.querySelector('[data-variants]');
  if (vt) { try { variants = JSON.parse(vt.textContent); } catch (e) {} }
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-price]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var addBtn = form.querySelector('[name="add"]');
  var stickyAdd = document.querySelector('[data-sticky-add]');

  function money(c) { return '$' + (c / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function selectedOptions() { return Array.prototype.map.call(form.querySelectorAll('[data-option]'), function (s) { return s.value; }); }
  function findVariant(opts) { return variants.filter(function (v) { return (v.options || []).every(function (o, i) { return o === opts[i]; }); })[0]; }
  function setBtn(el, available) { if (!el) return; el.disabled = !available; el.textContent = available ? 'Add to cart' : 'Sold out'; }

  function update() {
    if (!variants.length) return;
    var v = findVariant(selectedOptions());
    if (!v) { setBtn(addBtn, false); setBtn(stickyAdd, false); return; }
    idInput.value = v.id;
    if (priceEl) priceEl.innerHTML = money(v.price);
    if (stickyPrice) stickyPrice.textContent = money(v.price);
    setBtn(addBtn, v.available); setBtn(stickyAdd, v.available);
  }
  form.querySelectorAll('[data-option]').forEach(function (s) { s.addEventListener('change', update); });

  function add() {
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: idInput.value, quantity: 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      if (window.CartDrawer) { window.CartDrawer.refresh().then(function () { window.CartDrawer.open(); }); }
    });
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
  if (stickyAdd) stickyAdd.addEventListener('click', add);

  // reveal sticky bar when the main add block scrolls out of view
  var sticky = document.querySelector('[data-pdp-sticky]');
  var addBlock = form.querySelector('[data-add-block]');
  if (sticky && addBlock && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.hidden = en.isIntersecting; });
    }, { rootMargin: '0px 0px -60px 0px' }).observe(addBlock);
  }
})();

/* live "people viewing" count — gentle fluctuation within 13–150 */
(function () {
  var el = document.querySelector('[data-watching]');
  if (!el) return;
  setInterval(function () {
    var n = parseInt(el.textContent, 10) || 20;
    n = Math.max(13, Math.min(150, n + (Math.floor(Math.random() * 5) - 2)));
    el.textContent = n;
  }, 4000);
})();

/* "X sold in last Y hours" — deterministic per product/day so the same
   buyer sees a stable number for that session, but it rotates daily.
   Bounds: 7–100 sold, 1–23 hours. */
(function () {
  var wrap = document.querySelector('[data-sold-recent]');
  if (!wrap) return;
  var nEl = wrap.querySelector('[data-sold-n]');
  var hEl = wrap.querySelector('[data-sold-h]');
  if (!nEl || !hEl) return;

  // Seed from product handle + today's date so values are stable per page.
  var seed = (location.pathname + new Date().toDateString())
    .split('')
    .reduce(function (a, c) { return ((a << 5) - a + c.charCodeAt(0)) | 0; }, 0);
  function rand(min, max) {
    seed = (seed * 9301 + 49297) % 233280;
    var r = seed / 233280;
    return Math.floor(r * (max - min + 1)) + min;
  }
  var sold = rand(7, 100);
  var hours = rand(1, 23);
  nEl.textContent = sold;
  hEl.textContent = hours;

  // Tiny live nudge every ~25s — drift +/- 1 sold so it feels alive without lying.
  setInterval(function () {
    var cur = parseInt(nEl.textContent, 10) || sold;
    var next = Math.max(7, Math.min(100, cur + (Math.random() < 0.5 ? 1 : 0)));
    if (next !== cur) {
      nEl.textContent = next;
      wrap.style.animation = 'none';
      // force reflow then re-apply for the pop animation
      void wrap.offsetWidth;
      wrap.style.animation = '';
    }
  }, 25000);
})();

/* ============================================================
   URGENCY — same-day dispatch countdown
   ============================================================ */
(function () {
  var el = document.querySelector('[data-dispatch]');
  if (!el) return;
  var txt = el.querySelector('[data-dispatch-text]');
  var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
  if (isNaN(cutoff)) cutoff = 14;
  function p(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = new Date();
    var c = new Date(); c.setHours(cutoff, 0, 0, 0);
    if (now >= c) { el.classList.remove('ship-bar--urgent'); txt.innerHTML = 'Order now — ships the next business day &middot; free over $250'; return; }
    var diff = Math.floor((c - now) / 1000);
    var h = Math.floor(diff / 3600), m = Math.floor((diff % 3600) / 60), s = diff % 60;
    el.classList.add('ship-bar--urgent');
    txt.innerHTML = 'Order within <strong>' + p(h) + ':' + p(m) + ':' + p(s) + '</strong> for <strong>same-day dispatch</strong>';
  }
  tick(); setInterval(tick, 1000);
})();

/* ============================================================
   CART DONATION add-on
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-donate-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant');
    if (!id) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { return r.json(); }).then(function () {
      if (window.CartDrawer) { window.CartDrawer.refresh(); }
      btn.classList.add('is-added'); btn.querySelector('[data-donate-cta]') && (btn.querySelector('[data-donate-cta]').textContent = 'Added ✓');
    }).catch(function () { btn.disabled = false; });
  });
})();
